<div class="flex flex-col w-80 min-w-80  gap-5  shadow-inner overflow-x-hidden relative">
  <div
    class="fixed w-inherit h-inherit flex flex-col max-h-screen-70 innerListScroll min-h-screen-70 bg-opacity-5 bg-zen top-20">
    <ng-content></ng-content>
  </div>
</div>